import { Link } from 'react-router-dom';
import { SCOPES } from '../../constants/scopes';
import * as jwtDecoder from '../../constants/helpers/admin/jwtDecoder';

interface HomeItem {
  icon: string;
  title: string;
  description: string;
  link: string;
  scope: SCOPES;
}

const homeItems: HomeItem[] = [
  {
    icon: 'pi-briefcase',
    title: 'Job Openings',
    description: 'Create, edit, and manage job openings. Keep track of positions and hiring progress.',
    link: '/jobs',
    scope: SCOPES.JOB_READ,
  },
  {
    icon: 'pi-calendar',
    title: 'Interviews',
    description: 'Schedule, review, and manage interviews. Access feedback and candidate evaluations.',
    link: '/interviews',
    scope: SCOPES.INTERVIEW_READ,
  },
  {
    icon: 'pi-file',
    title: 'Job Applications',
    description: 'Review and manage incoming job applications. Filter, sort, and process candidates efficiently.',
    link: '/applications',
    scope: SCOPES.APPLICATION_READ,
  },
  {
    icon: 'pi-user',
    title: 'Users',
    description: 'Manage and administer user accounts. Control access and permissions for administrative staff.',
    link: '/users',
    scope: SCOPES.USER_READ,
  },
  {
    icon: 'pi-file-pdf',
    title: 'Resumes',
    description: 'Manage and search resumes.  Filter, sort, and process candidates resumes efficiently.',
    link: '/resumes',
    scope: SCOPES.RESUME_READ,
  },
  {
    icon: 'pi-clone',
    title: 'Templates',
    description: 'Create and manage interview flow templates. Standardize the interview process for consistency.',
    link: '/templates',
    scope: SCOPES.TENANT_ADMIN,
  },
  {
    icon: 'pi-database',
    title: 'Lookups',
    description: "Manage lookup values and system settings. Customize the platform to fit your organization's needs.",
    link: '/lookups',
    scope: SCOPES.PORTAL_ADMIN,
  },
];

const Home = () => {

  return (
    <div className="container mx-auto px-3">
      <h1 className="text-2xl font-bold mb-2 text-center">Welcome to X-Interviewer Admin Panel</h1>
      <p className="mb-2 text-center">Here you can manage job openings, interviews, applications, and system settings.</p>
      <div className="grid">
        {homeItems.filter(item => jwtDecoder.checkScopeExistsInJwt(item.scope)).map((item) => (
          <div key={item.title} className="col-12 md:col-6 lg:col-3">
            <div className="bg-white shadow-md rounded-md p-4">
              <h2 className="text-lg font-semibold mb-2 flex items-center justify-content-center align-items-center">
                <i className={`pi ${item.icon} mr-2`}></i>{item.title}
              </h2>
              <p className="text-sm text-gray-600">{item.description}</p>
              <Link to={item.link} className="p-button mt-2 block text-center no-underline">
                Go to {item.title}<i className="pi pi-arrow-right ml-2 align-middle"></i>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Home